import { createAPI } from '../../common'

export default {
  // 批量添加版次
  postLayoutBatch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0cbudi', 'post', config),
  // 添加版次或叠
  postLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu', 'post', config),
  // 添加版栏关系
  postLayoutConfirm: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0dpogjsn', 'post', config),
  // 版次排序
  putLayoutSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0tpsu', 'put', config),
  // 删除版次
  deleteLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu', 'delete', config),
  // 查询栏目、版次关系
  getLayoutRels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0sfmt', 'get', config),
  // 查询版次
  getLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu', 'get', config),
  // 查询子版次或叠
  getLayoutSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0dijmet', 'get', config),
  // 根据栏目ID获取版面信息
  getLayoutColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0dpmvno', 'get', config),
  // 获取栏板关系列表
  getLayoutRelslist: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0sfmtmjtu', 'get', config),
  // 查询根版次
  getLayoutRoots: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0spput', 'get', config),
  // 查询根版次
  updateColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0vqebufMbzpvu', 'get', config),
  // 校验名称和code
  getLayoutCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu0difdl', 'get', config),
  putLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0tztmbzpvu', 'put', config)
}
